import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router, withDisabledInitialNavigation, withNavigationErrorHandler } from '@angular/router';

import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { errorInterceptor } from './app/api/error.iterceptor';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { UserService } from './app/services/user.service';
import { reloadOnStaleChunk } from './app/stale-chunk-reload';
import { appRoutes } from './app.routes';
import { RU } from './i18n/primeng-ru';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withDisabledInitialNavigation(), withNavigationErrorHandler(reloadOnStaleChunk)),
    provideAppInitializer(async () => {
      const router = inject(Router);
      // Сессия — cookie API (CRM-122): узнаём, кто вошёл, до первой навигации — guard-ам нужен пользователь.
      await inject(UserService).restore();
      router.initialNavigation();
    }),
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: { darkModeSelector: '.app-dark' }
      },
      translation: RU
    }),
    provideAnimations(),
    MessageService,
    ConfirmationService
  ]
};
